import { render, staticRenderFns } from "./ImportQuestionsModal.vue?vue&type=template&id=2463b4ea"
import script from "./ImportQuestionsModal.vue?vue&type=script&lang=js"
export * from "./ImportQuestionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports